/**
 * Normalize API error payloads for display (string or field => message map).
 */
export function firstApiErrorMessage(message) {
  if (message == null || message === "") {
    return "Something went wrong. Please try again.";
  }
  if (typeof message === "string") {
    return message;
  }
  if (typeof message === "object") {
    const values = Object.values(message);
    if (values.length > 0) {
      const first = values[0];
      return typeof first === "string" ? first : String(first);
    }
  }
  return "Something went wrong. Please try again.";
}
